/**
 * ACT004 热点「点击时」条件校验（与控制台 act004-verify-condition.js 一致）
 */

export function normalizeVerifyConditionType(raw) {
  const t = String(raw || '').trim().toUpperCase()
  if (t === 'TIME') return 'TIME'
  if (t === 'QUIZ') return 'QUIZ'
  if (t === 'CHECKIN_COUNT') return 'CHECKIN_COUNT'
  return 'PREREQUISITE'
}

export function normalizeVerifyMinCheckinCount(raw) {
  const n = parseInt(raw, 10)
  return Number.isFinite(n) && n > 0 ? n : 0
}

export function evaluateVerifyCheckinCountCondition(options) {
  const opts = options && typeof options === 'object' ? options : {}
  const min = normalizeVerifyMinCheckinCount(opts.minCheckinCount)
  if (min <= 0) return true
  const getCount =
    typeof opts.getCompletedPointCount === 'function' ? opts.getCompletedPointCount : () => 0
  const count = parseInt(getCount(), 10)
  return Number.isFinite(count) && count >= min
}

function isTruthy(raw) {
  if (raw === true || raw === 1 || raw === '1') return true
  if (raw === false || raw === 0 || raw === '0' || raw == null) return false
  return String(raw).toLowerCase() === 'true'
}

/** 热点是否启用了「点击时」条件校验 */
export function isVerifyConditionEnabled(hotspot) {
  const cond = hotspot && hotspot.verifyCondition
  return !!(cond && isTruthy(cond.needValidate))
}

/**
 * 是否已满足打卡条件（与点击时前置校验一致，供页面加载态展示未解锁图）
 * @param {object} ctx
 * @param {string[]} [ctx.checkedPointIndexes]
 * @param {object} [ctx.act004LimitDetailByPoint] 问答通过状态
 * @param {import('moment')} [ctx.moment]
 */
export function evaluateVerifyConditionSatisfied(hotspot, ctx) {
  if (!isVerifyConditionEnabled(hotspot)) return true
  const cond = hotspot.verifyCondition
  const type = normalizeVerifyConditionType(cond.conditionType)
  const checked = ctx && Array.isArray(ctx.checkedPointIndexes) ? ctx.checkedPointIndexes : []
  const isPreDone = (idx) => checked.some((c) => String(c) === String(idx))

  if (type === 'PREREQUISITE') {
    const indexes = Array.isArray(cond.prerequisiteIndexes) ? cond.prerequisiteIndexes : []
    if (indexes.length === 0) return true
    const isOr =
      cond.prerequisiteRelation === 'OR' || String(cond.prerequisiteRelation || '').toUpperCase() === 'OR'
    if (isOr) return indexes.some((n) => isPreDone(n))
    return indexes.every((n) => isPreDone(n))
  }
  if (type === 'CHECKIN_COUNT') {
    return evaluateVerifyCheckinCountCondition({
      minCheckinCount: cond.minCheckinCount,
      getCompletedPointCount: () => checked.length
    })
  }
  if (type === 'TIME') {
    const momentFn = ctx && ctx.moment
    if (typeof momentFn !== 'function') return true
    const now = momentFn()
    const start = cond.timeStart ? momentFn(cond.timeStart) : null
    const end = cond.timeEnd ? momentFn(cond.timeEnd) : null
    if (start && start.isValid() && now.isBefore(start)) return false
    if (end && end.isValid() && now.isAfter(end)) return false
    return true
  }
  if (type === 'QUIZ') {
    const pi = parseInt(hotspot && hotspot.index, 10)
    const map = ctx && ctx.act004LimitDetailByPoint
    if (!Number.isFinite(pi) || pi <= 0 || !map) return false
    const raw = map[pi]
    const quiz = raw && typeof raw === 'object' && raw.quiz && typeof raw.quiz === 'object' ? raw.quiz : null
    if (!quiz) return false
    return isTruthy(quiz.quizPassed)
  }
  return true
}

/** 页面加载态：是否展示未解锁图（须已配置图且条件未满足） */
export function shouldUseHotspotNotUnlockedImg(hotspot, ctx) {
  if (!isVerifyConditionEnabled(hotspot)) return false
  if (!String((hotspot && hotspot.notUnlockedImg) || '').trim()) return false
  return !evaluateVerifyConditionSatisfied(hotspot, ctx)
}

export const HOTSPOT_VERIFY_CONDITION_LOCKED_TOAST = '未达到满足打卡条件'
